import { render, staticRenderFns } from "./InfoContainer.vue?vue&type=template&id=5d99b077&scoped=true&functional=true&"
import script from "./InfoContainer.vue?vue&type=script&lang=js&"
export * from "./InfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./InfoContainer.vue?vue&type=style&index=0&id=5d99b077&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5d99b077",
  null
  
)

export default component.exports